/**
 * Work history and education, sourced from Rhico's CV. Newest first.
 * `end: null` means "present" — rendered as such by the timeline.
 */
export const EXPERIENCE = [
    {
        role: 'Junior Developer',
        company: 'Metavaro',
        location: 'Johannesburg, Gauteng',
        start: 'March 2024',
        end: null,
        highlights: [
            'Transitioned from Multimedia Specialist to Junior Software Developer.',
            'Upskilled into software development.',
            'Redesigned and rebuilt the company website.',
            'Client website development and maintenance.',
            "Refined the company's CRM platform UI for better mobile responsiveness and accessibility.",
            'Developed product components and UI elements for better user interactions on company systems.'
        ]
    },
    {
        role: 'Multimedia Specialist',
        company: 'Metavaro',
        location: 'Johannesburg, Gauteng',
        start: 'October 2022',
        end: 'March 2024',
        highlights: [
            'Produced over thirty promotional videos with marketing-related content using Adobe Premiere Pro, After Effects, Illustrator and Photoshop for company events, products and services.',
            'Refined client mascot design and illustrated 5 murals for a new office interior.',
            'Redefined client corporate identity and designed new corporate supplementary sales packages and documents for brokers, leveraging Adobe InDesign and Illustrator.',
            'Trained and consulted marketing staff in videography, photography, video and photo editing.',
            'Consulted on user interface design with the development team.'
        ]
    },
    {
        role: 'Multimedia Designer',
        company: 'Metavaro',
        location: 'Johannesburg, Gauteng',
        start: 'October 2020',
        end: 'March 2022',
        highlights: [
            'Produced static/dynamic social media content as an in-house multimedia designer.',
            'Designed corporate promotional material such as brochures, documentation, service info-sheets, car branding, apparel and infographics for Mont Blanc Financial Services.',
            'Consulted on user interface design and usability for company systems.'
        ]
    },
    {
        role: 'Junior Graphic Designer',
        company: 'eNew Media',
        location: 'Sandton, Gauteng',
        start: 'April 2019',
        end: 'September 2020',
        highlights: ['Produced dynamic video and motion-graphic social media content.', 'Designed corporate branding material such as brochures, corporate documentation, merchandise and infographics.']
    }
];

export const EDUCATION = [
    {
        title: 'Bachelor of Art — 4 Year Degree',
        institution: 'North-West University',
        location: 'Potchefstroom, North-West',
        year: 2018,
        note: '2nd Speaker, Villagers Debate Team · Design Student Faculty Assistant · Creativity Centre Assistant'
    },
    {
        title: 'Visual Concept Development',
        institution: 'Creativity Centre',
        location: 'Potchefstroom, North-West',
        year: 2018
    },
    {
        title: 'Character Development for Graphic Novels',
        institution: 'Creativity Centre',
        location: 'Potchefstroom, North-West',
        year: 2017
    },
    {
        title: 'Photography Level 1',
        institution: 'Creativity Centre',
        location: 'Potchefstroom, North-West',
        year: 2016
    },
    {
        title: 'National Senior Certificate',
        institution: 'Hoërskool Linden',
        location: 'Johannesburg, Gauteng',
        year: 2013
    }
];

export const SKILLS = {
    technical: ['Photoshop', 'Illustrator', 'InDesign', 'Premiere Pro', 'After Effects', 'Lightroom Classic', 'Figma'],
    languages: [
        { label: 'Afrikaans', level: 'C1' },
        { label: 'English', level: 'C1' }
    ],
    interests: ['Urban Sketching', 'Digital & Traditional Art', 'Running', 'Science & Technology', 'Photography', 'Gaming']
};
